module.exports = __webpack_public_path__ + "static/media/arrow-alt-from-bottom.514e2f27.svg";